@if (displayForm) {
<div class="content-container card-benefit-summary-table">
  @if (header) {
  <div class="title d-inline-flex w-100">
    <mwp-text-translate [text]="header" [jsonKey]="header" />
  </div>
  }
  <div class="content pb-3">
    <table>
      <thead>
        <tr class="card-benefit-table-row">
          @if (displayInfoColumn) {
          <th style="width: 3%;">
          </th>
          }
          @if (displayCategoryColumn) {
          <th>
            <mwp-text-translate text="Category" jsonKey="category" />
          </th>
          }
          @if (displayBenefitColumn) {
          <th>
            <mwp-text-translate text="Benefit" jsonKey="benefit" />
          </th>
          }
          <th [ngStyle]="{'width': isEnrollmentCheckout ? '28%': '14%;'}">
            <mwp-text-translate text="Tier" jsonKey="tier" />
          </th>
          <th [ngStyle]="{'width': isEnrollmentCheckout ? '12%': '9%;'}">
            <mwp-text-translate text="Effective" jsonKey="effective" />
          </th>
          <th [ngStyle]="{'width': isEnrollmentCheckout ? '12%': '9%;'}">
            <mwp-text-translate text="Termination" jsonKey="termination" />
          </th>
          @if (displayProcessColumn) {
          <th style="width: 13%;">
            <mwp-text-translate text="Process" jsonKey="process" />
          </th>
          }
          <th [ngStyle]="{'width': isEnrollmentCheckout ? '9%': '9%;'}" class="pe-2 text-end">
            <mwp-text-translate text="Cost" jsonKey="cost" />
          </th>
        </tr>
      </thead>
      <tbody>
        @for (benefitCard of benefitCards; track benefitCard) {
        <tr class="card-benefit-table-row">
          @if (displayInfoColumn) {
          <td>
            <div class="object-rotate" [ngClass]="{'rotate-down': isEnrollmentSummary || enableToggle && benefitCard.uniqueID == selectedBenefituniqueID}">
              @if (benefitCard.coveredMembers?.length || benefitCard.requestedEOIs?.length) {
                <mwp-svg-icon [SvgMatType]="svgType.ChevronRight" class="selectable" (click)="toggleRow(benefitCard)"/>
              }
            </div>
          </td>
          }
          @if (displayCategoryColumn) {
            <td>{{ benefitCard.categoryForDisplay }}</td>
          }
          @if (displayBenefitColumn) {
          <td>
            <div class="d-inline-flex align-items-center">
              @if (benefitHasPendingEOI(benefitCard)) {
              <div class="pt-2">
                <mwp-svg-icon [SvgMatType]="svgType.SmsFailed" class="error me-2" [ToolTipMessage]="'Pending Evidence of Insurability!'" [ToolTipClass]="'error'" />
              </div>
              }
              <div>
                {{ benefitCard.enrollmentName }}
              </div>
            </div>
          </td>
          }
          <td>{{ benefitCard.tier }}</td>
          <td>{{ benefitCard.effectiveDate }}</td>
          <td>{{ benefitCard.terminationDate }}</td>
          @if (displayProcessColumn) {
          <td>{{ benefitCard.processInfo }}</td>
          }
          <td class="pe-2 text-end">{{ benefitCard.deductionForDisplay }}</td>
        </tr>
        @if (benefitCard.coveredMembers?.length && (!enableToggle || (enableToggle && benefitCard.uniqueID == selectedBenefituniqueID)|| isEnrollmentSummary) ) {
        <tr class="card-benefit-table-row" @slideDown>
          <td class="child-table" [attr.colspan]="colSpanWidth">
            <table>
              <thead>
                <tr class="card-benefit-table-row">
                  <th>
                    <mwp-text-translate text="Name" jsonKey="name" />
                  </th>
                  <th>
                    <mwp-text-translate text="Relationship" jsonKey="relationship" />
                  </th>
                  <th>
                    <mwp-text-translate text="Effective" jsonKey="effective" />
                  </th>
                  <th>
                    <mwp-text-translate text="Termination" jsonKey="termination" />
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (coveredMember of benefitCard.coveredMembers; track coveredMember) {
                <tr>
                  <td>
                    <div class="d-inline-flex align-items-center">
                      <div>
                        {{ coveredMember.name }}
                      </div>
                      @if (coveredMember.disabledMessage) {
                      <div class="pt-2">
                        <mwp-svg-icon [SvgMatType]="svgType.SmsFailed" class="error ms-2" [ToolTipMessage]="coveredMember.disabledMessage" [ToolTipClass]="'error'" />
                      </div>
                      }
                    </div>
                  </td>
                  <td>{{ coveredMember.relationship }}</td>
                  <td>{{ coveredMember.effectiveDate }}</td>
                  <td>{{ coveredMember.terminationDate }}</td>
                </tr>
                }
              </tbody>
            </table>
          </td>
        </tr>
        }
        @if (benefitCard.requestedEOIs?.length && (!enableToggle || (enableToggle && benefitCard.uniqueID == selectedBenefituniqueID)|| isEnrollmentSummary) ) {
        <tr class="card-benefit-table-row" @slideDown>
          <td class="child-table" [attr.colspan]="colSpanWidth">
            <table>
              <thead>
                <tr class="card-benefit-table-row">
                  <th>
                    <mwp-text-translate text="Tier" jsonKey="tier" />
                  </th>
                  <th>
                    <mwp-text-translate text="Effective" jsonKey="effective" />
                  </th>
                  <th>
                    <mwp-text-translate text="Termination" jsonKey="termination" />
                  </th>
                  <th>
                    <mwp-text-translate text="Deduction" jsonKey="deduction" />
                  </th>
                  <th>
                    <mwp-text-translate text="Tobacco Rate" jsonKey="tobaccoRate" />
                  </th>
                  <th>
                    <mwp-text-translate text="Age" jsonKey="Age" />
                  </th>
                  <th>
                    <mwp-text-translate text="Pending Underwriting" jsonKey="pendingUnderwriting" />
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (requestedEOI of benefitCard.requestedEOIs; track requestedEOI) {
                <tr class="card-benefit-table-row">
                  <td>{{ requestedEOI.tier }}</td>
                  <td>{{ requestedEOI.effectiveDate }}</td>
                  <td>{{ requestedEOI.terminationDate }}</td>
                  <td>{{ requestedEOI.deductionForDisplay }}</td>
                  <td>{{ requestedEOI.tobaccoRated }}</td>
                  <td>{{ requestedEOI.age }}</td>
                  <td>{{ requestedEOI.pendingUnderwriting }}</td>
                </tr>
                }
              </tbody>
            </table>
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
    @if (!benefitCards || benefitCards.length === 0) {
    <div class="d-flex justify-content-center w-100 table-no-data">
      <span>
        <mwp-text-translate text="No Data Found!" jsonKey="noDataFound" />
      </span>
    </div>
    }
  </div>
</div>
}

@if (showSummary && showSummaryTotal) {
<div class="content-container  card-benefit-summary-table" [ngClass]="{'mt-3': !showSummaryGridOnly}">
  @for (totalCard of totalCards; track totalCard) {
  <div>
    @if (header) {
    <div class="title d-inline-flex w-100">
      @if (deductionsHeader) {
        <span class="me-1">
          <mwp-text-translate [text]="deductionsHeader" [jsonKey]="deductionsHeader" />
        </span>
        <mwp-text-translate [text]="totalCard.frequencyDisplay" [jsonKey]="totalCard.frequencyDisplay" />
      }  @else {
        <span class="me-1">
          <mwp-text-translate [text]="totalCard.frequencyDisplay" [jsonKey]="totalCard.frequencyDisplay" />
        </span>
        <mwp-text-translate text="DEDUCTIONS" jsonKey="deductions" />
      }
    </div>
    }
    <div class="content pb-3">
      <table>
        <thead>
          <tr class="card-benefit-table-row">
            <th class="ps-2">
              <mwp-text-translate text="Total Pre-Tax" jsonKey="totalPreTax" />
            </th>
            <th class="text-center">
              <mwp-text-translate text="Total Post-Tax" jsonKey="totalPostTax" />
            </th>
            <th class="pe-2 text-end">
              <mwp-text-translate text="Total Cost" jsonKey="totalCost" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="card-benefit-table-row">
            <td class="ps-2">
              {{ totalCard.totalPretax | currency }}
            </td>
            <td class="text-center">
              {{ totalCard.totalPosttax | currency }}
            </td>
            <td class="pe-2 text-end">
              {{ totalCard.totalCost| currency }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  }
</div>
}

@if (showSummary && showCafeteriaSummaryTotal) {
<div class="content-container" [ngClass]="{'mt-3': !showSummaryGridOnly}">
  @if (header) {
  <div class="title d-inline-flex w-100">
    @if (deductionsHeader) {
      <span class="me-1">
        <mwp-text-translate [text]="deductionsHeader" [jsonKey]="deductionsHeader" />
      </span>
      {{ cafeteriaTotalCard.coreFrequencyDisplay }}
    }  @else {
      <span class="me-1">
        {{ cafeteriaTotalCard.coreFrequencyDisplay }}
      </span>
      <mwp-text-translate text="DEDUCTIONS" jsonKey="deductions" />
    }
  </div>
  }
  <div class="content">
    <table>
      <thead>
        <tr class="card-benefit-table-row">
          <th>
            <mwp-text-translate text="Total Cost" jsonKey="totalCost" />
          </th>
          <th>
            <mwp-text-translate text="County Contribution" jsonKey="countyContribution" />
          </th>
          <th>
            <mwp-text-translate text="Employee Contribution" jsonKey="employeeContribution" />
          </th>
          <th class="pe-2 text-end">
            <mwp-text-translate text="Tax Status" jsonKey="employeeTaxSatus" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="card-benefit-table-row">
          <td>
            {{ cafeteriaTotalCard.totalCoreAmount | currency}}
          </td>
          <td>
            {{ cafeteriaTotalCard.coreEmployerAmount | currency}}
          </td>
          <td>
            {{ cafeteriaTotalCard.coreEmployeeAmount | currency }}
          </td>
          <td class="pe-2 text-end">
            {{ cafeteriaTotalCard.coreEmployeeTaxStatus }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
}

@if (showSummary && showCafeteriaSummaryTotal && !cafeteriaTotalCard.showCoreOnly) {
<div class="content-container">
  @if (header) {
  <div class="title mb-2 d-inline-flex">
    <span class="me-1">
      {{ cafeteriaTotalCard.fsaFrequencyDisplay }}
    </span>
  </div>
  }
  <div class="content mb-3">
    <table>
      <thead>
        <tr class="card-benefit-table-row">
          <th>
            <mwp-text-translate text="FSA Deduction" jsonKey="fsaDeduction" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="card-benefit-table-row">
          <td>
            {{ cafeteriaTotalCard.fsaAmount | currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  @if (header) {
  <div class="title mb-2 d-inline-flex">
    <span class="me-1">
      {{ cafeteriaTotalCard.voluntaryFrequencyDisplay }}
    </span>
  </div>
  }
  <div class="content mb-3">
    <table>
      <thead>
        <tr class="card-benefit-table-row">
          <th class="ps-2">
            <mwp-text-translate text="Total Pre-Tax" jsonKey="totalPreTax" />
          </th>
          <th class="text-center">
            <mwp-text-translate text="Total Post-Tax" jsonKey="totalPostTax" />
          </th>
          <th class="pe-2 text-end">
            <mwp-text-translate text="Total Cost" jsonKey="totalCost" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="card-benefit-table-row">
          <td class="ps-2">
            {{ cafeteriaTotalCard.voluntaryPretaxAmount | currency }}
          </td>
          <td class="text-center">
            {{ cafeteriaTotalCard.voluntaryPosttaxAmount | currency }}
          </td>
          <td class="pe-2 text-end">
            {{ cafeteriaTotalCard.totalVoluntaryAmount| currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
}